import { render, staticRenderFns } from "./ProductIncAndDesc.vue?vue&type=template&id=279556a0&scoped=true&"
import script from "./ProductIncAndDesc.vue?vue&type=script&lang=js&"
export * from "./ProductIncAndDesc.vue?vue&type=script&lang=js&"
import style0 from "./ProductIncAndDesc.vue?vue&type=style&index=0&id=279556a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "279556a0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Administrator\\Desktop\\gtzn\\FreeGoShop\\client_web_food_market\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('279556a0', component.options)
    } else {
      api.reload('279556a0', component.options)
    }
    module.hot.accept("./ProductIncAndDesc.vue?vue&type=template&id=279556a0&scoped=true&", function () {
      api.rerender('279556a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shop/ProductIncAndDesc.vue"
export default component.exports